module.exports = "/_next/static/images/ge-8210444e1d1fef8e70c8d666136cb57d.svg";